import Controller from '@ember/controller';

import { Spinner } from '@repo/design-system-kit';

import { MainLayout } from 'register-partners-js/react/components/layouts/main';

import styles from './styles.module.css';

export default class RegistrationKycLoadingControllerController extends Controller {
  mainLayout = MainLayout;

  spinner = Spinner;
  styles = styles;
}
